import React, { useState } from 'react';

import { ContentComponent, UiComponent } from 'components';
import { useIsMobile, usePageOption } from 'hooks';
import { ContentsQuery } from 'queries';
import { SearchContentsFilterType } from 'types';

function DesktopList() {
  const pageState = usePageOption();
  const [filter, setFilter] = useState<SearchContentsFilterType>({});
  const { data } = ContentsQuery.useGetAll({
    pageType: 'LIST',
    page: pageState.pageOption.page,
    size: pageState.pageOption.size,
    ...filter,
  });

  return (
    <ContentComponent.List
      toolbar={
        <ContentComponent.Filter filter={filter} handleFilter={setFilter} />
      }
      {...pageState}
      totalPage={data?.totalPage}
      data={data?.data || []}
    />
  );
}

function List() {
  const isMobile = useIsMobile();

  const title = <UiComponent.PageTitle>콘텐츠 관리</UiComponent.PageTitle>;

  if (isMobile) return <ContentComponent.MobileList title={title} />;

  return (
    <>
      {title}
      <DesktopList />
    </>
  );
}

export default List;
